import { supabase, isConfigured } from './supabase';

function normalizeMsg(msg, currentUserId) {
  return {
    ...msg,
    from: msg.from_user_id || msg.from,
    read: Array.isArray(msg.read_by)
      ? msg.read_by.includes(currentUserId)
      : (msg.read || false),
  };
}

const messageService = {
  normalizeMsg,

  async getAll(userId) {
    if (!isConfigured || !userId) return [];
    const { data, error } = await supabase
      .from('messages')
      .select('*')
      .or(`from_user_id.eq.${userId},to_user_ids.cs.{${userId}}`)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return (data || []).map(m => normalizeMsg(m, userId));
  },

  async send(toUserIds, message) {
    if (!isConfigured) throw new Error('Supabase nicht konfiguriert');
    const ids = Array.isArray(toUserIds) ? toUserIds : [toUserIds];
    const { error } = await supabase.from('messages').insert({
      from_user_id: message.from,
      from_name: message.fromName,
      to_user_ids: ids,
      type: message.type || 'general',
      subject: message.subject || '',
      body: message.body || '',
      status: message.status || 'pending',
      payload: message.payload || null,
      read_by: [],
    });
    if (error) throw error;
  },

  async markRead(messageId, userId) {
    if (!isConfigured || !messageId || !userId) return;
    const { data } = await supabase
      .from('messages').select('read_by').eq('id', messageId).single();
    const readBy = [...new Set([...(data?.read_by || []), userId])];
    await supabase.from('messages').update({ read_by: readBy }).eq('id', messageId);
  },

  async updateStatus(messageId, status) {
    if (!isConfigured || !messageId) return;
    const { error } = await supabase
      .from('messages').update({ status }).eq('id', messageId);
    if (error) throw error;
  },

  subscribe(userId, onInsert, onUpdate) {
    if (!isConfigured || !userId) return () => {};
    const channel = supabase
      .channel(`msgs_${userId}`)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'messages' }, p => {
        const msg = p.new;
        if (msg.from_user_id === userId || msg.to_user_ids?.includes(userId)) {
          onInsert?.(normalizeMsg(msg, userId));
        }
      })
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'messages' }, p => {
        const msg = p.new;
        if (msg.from_user_id === userId || msg.to_user_ids?.includes(userId)) {
          onUpdate?.(normalizeMsg(msg, userId));
        }
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  },
};

export default messageService;
